<template>
<div :class="['toast', type]" ref="toast">
    <div class="content" v-html="message"></div>
</div>
</template>

<script>
export default {
    name: "toast",

    data () {
        return {
            message: "",
            type: "normal",
            timeout_id: null
        }
    },

    created () {
        this.$eventManager.on("add-toast", (options) => {
            this.message = options.message

            if (options.type) {
                this.type = options.type
            } else {
                this.type = "normal"
            }

            // use a timeout to wait for the DOM to finish updating
            window.setTimeout(() => {
                this.moveToast()
            }, 0)
        })
    },

    methods: {
        /**
         * Move the toast into viewing position when the message has been updated.
         */
        moveToast () {
            // move the toast into viewing position
            const height = this.$refs.toast.clientHeight
            this.$refs.toast.style.top = `calc(100% - ${height}px)`

            // reset the previous timeout, if it exists
            if (this.timeout_id !== null) {
                window.clearTimeout(this.timeout_id)
            }

            // move the toast back out of viewing position
            this.timeout_id = window.setTimeout(() => {
                this.$refs.toast.style.top = "100%"
                this.timeout_id = null
            }, 3000)
        }
    }
}
</script>

<style>
.toast {
    background: rgba(0, 0, 0, 0.75);
    box-shadow: 0 -2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
    color: #fff;
    left: 0;
    padding: 20px;
    position: fixed;
    top: 100%;
    transition: all 0.5s ease;
    width: 100%;
    z-index: 2;
}

.toast.error {
    background: rgba(200, 0, 0, 0.95);
}

.toast.success {
    background: rgba(0, 200, 135, 0.95);
}
</style>



// WEBPACK FOOTER //
// src/components/Toast.vue